import { initWebWorker } from 'landings/__assets__/scripts/services/workerHandler'
import { initMobileAppSlider } from 'landings/__assets__/scripts/components/mobile-app-section-slider'

initWebWorker()
initMobileAppSlider()
